import { eTipoPermissao } from '@/enums/ePermissoes';

/**
 * Fechamento de Turmas — migração de `SAEWEBC/WEB/MenuAcademico/FecharTurma.aspx`.
 *
 * **Uma rota para os dois recortes.** O legado abria a MESMA página duas vezes, por
 * `?modoensino=0` (Fechamento Anual) e `?modoensino=1` (Fechamento Semestral), e o botão trocava
 * de nome conforme o parâmetro. A tela nova mostra os dois juntos no grid, cada linha dizendo se
 * é anual, semestral ou livre — não há query string para atravessar (ver a armadilha do
 * `/proxylegado`, em que a query string não passa).
 *
 * Permissão PRÓPRIA (`FECHAMENTODETURMASNOVO_MENU_300600199`), que cobre as duas do legado
 * (300600101 e 300600201). Ver
 * `saeweb-database-sql/consultebase/scripts/2026-09-02-Permissao-FechamentoTurmas.sql`.
 */
export default [
  {
    description: 'Fechamento de Turmas',
    path: '/academico/fechamentoturmas',
    name: 'fechamento_turmas',
    component: () => import('@/views/academico/fechamentoturmas/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.FECHAMENTODETURMASNOVO_MENU_300600199],
    },
    goesToMenu: true,
  },
];
